import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { persistAutoSubmit, resolveAutoSubmit } from '../data/preferences';
import type { Region } from '../data/words';
import { persistRegion, resolveRegion } from '../data/words';

type SettingsState = {
  autoSubmit: boolean;
  region: Region;
};

/* Read once on load: the picker is the only thing that changes these afterwards. */
const initialState: SettingsState = {
  autoSubmit: resolveAutoSubmit(),
  region: resolveRegion(),
};

const settingsSlice = createSlice({
  initialState,
  name: 'settings',
  reducers: {
    setAutoSubmit(state, action: PayloadAction<boolean>) {
      const { payload: autoSubmit } = action;

      state.autoSubmit = autoSubmit;
      persistAutoSubmit(autoSubmit);
    },
    setRegion(state, action: PayloadAction<Region>) {
      const { payload: region } = action;

      state.region = region;
      persistRegion(region);
    },
  },
});

const { actions, reducer } = settingsSlice;

export const { setAutoSubmit, setRegion } = actions;

export default reducer;
